/** @jsx isolateComponent */

// TODO: Remove this file once this component is consumable from app/developer-v3/teams/team-technical-support-operations/get-help
import { useRef, useState } from 'react';

import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import {
  Animation,
  Colors,
  Icon,
  Shadows,
  Surface,
  Text,
} from '@zapier/design-system';

import Link from 'app/common/components/Link';

type SizeType = 'small' | 'medium' | 'large';

type DocLinkProps = {
  /** Link */
  href: string;
  /** Title */
  title: string;
  /** Size to display. */
  size?: SizeType;
};

const Styles = {
  container: (size: SizeType) => css`
    border: 1px solid ${Colors.GrayWarm2};
    border-radius: 5px;
    display: grid;
    grid-column-gap: ${size === 'small' ? '10px' : '20px'};
    grid-template-columns: min-content 1fr min-content;
    align-items: center;
    padding: 0 ${size === 'small' ? '10px' : '20px'};
    height: 50px;
    transition-property: box-shadow, border-color, background-color, color;
    transition-timing-function: ${Animation.transitionTimingFunction};
    transition-duration: ${Animation.transitionDuration};
    &:hover,
    &:focus {
      background-color: ${Colors.PrimeWhite};
      box-shadow: ${Shadows.elevation10};
      border-color: ${Colors.GrayWarm4};
    }
  `,
  title: css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `,
  rightIcon: (isActive: boolean) => css`
    display: flex;
    transition-property: opacity;
    transition-timing-function: ${Animation.transitionTimingFunction};
    transition-duration: ${Animation.transitionDuration};
    opacity: ${isActive ? 1 : 0};
  `,
};

/** Renders a single doc for `<DocLinks>`. */
const DocLink = ({ href, size = 'large', title }: DocLinkProps) => {
  const [isActive, setIsActive] = useState(false);

  const onBlur = useRef(() => setIsActive(false)).current;
  const onFocus = useRef(() => setIsActive(true)).current;
  const onMouseEnter = useRef(() => setIsActive(true)).current;
  const onMouseLeave = useRef(() => setIsActive(false)).current;

  return (
    <Link
      href={href}
      onBlur={onBlur}
      onFocus={onFocus}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      target="_blank"
    >
      <Surface
        backgroundColor="GrayWarm2"
        shadow={isActive ? 'elevation5' : undefined}
      >
        <div css={Styles.container(size)}>
          <Icon
            canAcceptPointerEvents={true}
            color={isActive ? 'UiPrimaryStrongest' : 'PrimeBlack'}
            name="fileFilledFill"
            size={18}
          />
          <Text
            color={isActive ? 'UiPrimaryStronger' : undefined}
            css={Styles.title}
            fontWeight={600}
          >
            {title}
          </Text>
          <span css={Styles.rightIcon(isActive)}>
            <Icon name="arrowOffsite" size={18} />
          </span>
        </div>
      </Surface>
    </Link>
  );
};

export default DocLink;
